import React, { createContext, useContext, useState, useEffect } from 'react';

export interface ToastSettingsContextValue {
  persistToasts: boolean;
  setPersistToasts: React.Dispatch<React.SetStateAction<boolean>>;
}

const ToastSettingsContext = createContext<ToastSettingsContextValue | null>(null);

export const useToastSettings = (): ToastSettingsContextValue | null => useContext(ToastSettingsContext);

export const ToastSettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const [persistToasts, setPersistToasts] = useState(() => {
    const savedSetting = sessionStorage.getItem('persistToasts');
    return savedSetting ? JSON.parse(savedSetting) : false;
  });

  useEffect(() => {
    sessionStorage.setItem('persistToasts', JSON.stringify(persistToasts));
  }, [persistToasts]);

  return (
    <ToastSettingsContext.Provider value={{ persistToasts, setPersistToasts }}>
      {children}
    </ToastSettingsContext.Provider>
  );
};

export default ToastSettingsContext;
